module.exports = __webpack_public_path__ + "femember/img/example_idea.5999fae0.png";